<template>
  <div id="courseLoadingImage" v-if="isLoading">
    <img class="d-none d-md-block mb-4" style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/coursePlaceholder.svg" alt="" />
    <img class="d-md-none mb-4" style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/coursePlaceholderMobile.svg" alt="" />
  </div>

  <div v-if="courses" class="bg-white mb-4 px-5 py-1 rounded-corners-10 courses">
    <div class="text-primary my-3">
      <h5 class="font-weight-bolder" style="font-size: x-large">
        {{ $t('CategoryPage.courses') }}
      </h5>
    </div>
    <div class="splide courseSplide newFeatureSlider" aria-label="Slider for Courses">
      <div class="sands-article-vueslidercontainer splide__track">
        <div class="splide__list">
          <div class="mb-5 mt-3 mt-lg-2 splide__slide" v-for="(course, i) in courses" :key="i">
            <div aria-hidden="false" class="h-100">
              <div class="card-container-courses">
                <a v-if="course.marketingUrl" :href="`${course.marketingUrl}`">
                  <img alt="Card image cap" class="card-img-top course-card-image fixed-aspect-ratio" loading="lazy"
                    v-if="course.teaserImage && course.teaserImage.xxx" :src="course.teaserImage.xxx" />
                    <img alt="Card image cap" class="card-img-top course-card-image fixed-aspect-ratio" loading="lazy"
                    v-if="course.teaserImage && !course.teaserImage.xxx" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/loading_Image_top_image.svg" />
                </a>
                <a v-else>
                  <img alt="Card image cap" class="card-img-top course-card-image fixed-aspect-ratio" loading="lazy"
                    v-if="course.teaserImage && course.teaserImage.xxx" :src="course.teaserImage.xxx" />
                    <img alt="Card image cap" class="card-img-top course-card-image fixed-aspect-ratio" loading="lazy"
                    v-if="course.teaserImage && !course.teaserImage.xxx" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/loading_Image_top_image.svg" />
                </a>


                <div class="card-body d-flex flex-column justify-content-between rounded-bottom" style="
                    background: linear-gradient(
                      rgb(51, 255, 104) -160px,
                      rgb(12, 23, 21) 380px
                    );
                  ">
                  <a v-if="course.marketingUrl" :href="`${course.marketingUrl}`">
                    <p v-if="course.name" class="card-text text-white course-name-card text-break">
                      {{ truncateCourseName(course.name, 60) }}
                    </p>
                  </a>
                  <a v-else>
                    <p v-if="course.name" class="card-text text-white course-name-card text-break">
                      {{ truncateCourseName(course.name, 60) }}
                    </p>
                  </a>
                  <div class="align-items-end d-flex h-75 w-100">
                    <div class="d-flex mt-3 text-white flex-wrap course-card-footer">
                      <div class="d-flex mr-3" v-if="course.duration">
                        <i class="material-icons font-s-course"> timer </i>
                        <p class="align-self-center m-0 ml-1">
                          {{ course.duration }}<span class="ml-1">Teile</span>
                        </p>
                      </div>
                      <div class="d-flex mr-3" v-if="course.level">
                        <i class="material-icons font-s-course"> school </i>
                        <p class="align-self-center m-0 ml-2">
                          {{ course.level }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import CONCORD_QUERIES from "../../services/concord_queries.js";
import { watch } from "vue";
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from '../../services/axios_queries.js';

export default {
  name: "categoryCourses",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      courses: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      splide: null,
      firstTimeInViewport: true,
      initialDataLoaded: false,
    };
  },

  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.box1Ref = document.getElementById("courseLoadingImage");

      if (this.box1Ref) {
        const isVisible = useElementVisible(this.box1Ref);
        if (isVisible && isVisible.value && isVisible.value == true) {
          this.firstTimeInViewport = false;
          this.loadInitialData();
        }

        watch(isVisible, (newValue) => {
          if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
          }
          // Do something when isVisible changes
        });
      }
                      
                      
      this.emitter.on('eventsProcessed', () => {
            this.firstTimeInViewport = false;
            this.loadInitialData();
      });
    }, 500);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
  },

  methods: {
    loadInitialData() {
      if (!this.initialDataLoaded) {
        this.initialDataLoaded = true;
        let bbCoursesLoadingParams = {
          page: 1,
          pagesize: 16,
          querystring: this.settingsPerm.cat,
          transientKey: this.settingsPerm.cat + "-cat-bbCourses-tutorials-vue",
          query: "cat-bbCourses-tutorials-vue",
          url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-bbCourses-tutorials-vue.json'
        };
        axios_queries.loadPublicData(bbCoursesLoadingParams).then((concordData) => {
            if (
              concordData &&
              concordData != null &&
              concordData != undefined &&
              concordData != ""
            ) {
              if (
                concordData.advancedSearch &&
                concordData.advancedSearch.blockbusterCourses &&
                concordData.advancedSearch.blockbusterCourses.Courses &&
                concordData.advancedSearch.blockbusterCourses.Courses.length >= 3
              ) {
                this.displayCourses(
                  concordData.advancedSearch.blockbusterCourses.Courses
                );
              } else {
                this.isLoading = false;
                this.emitter.emit('coursesProcessed', true);
              }
            } else {
              this.isLoading = false;
              this.emitter.emit('coursesProcessed', true);
            }
        });
      }
    },

    displayCourses(data) {
      this.courses = data;
      this.isLoading = false;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_COURSES;
      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (concordData && 
          concordData.advancedSearch &&
          concordData.advancedSearch.blockbusterCourses &&
          concordData.advancedSearch.blockbusterCourses.Courses &&
          concordData.advancedSearch.blockbusterCourses.Courses.length
        ) {
          const newCourses = concordData.advancedSearch.blockbusterCourses.Courses;
          // console.log('New Courses',newCourses);
          this.courses = [...this.courses, ...newCourses];
          // console.log('courses',this.courses);
          this.currentPage = nextPage;
          this.mount_splide();
        }
    },

    addMovedEventListener() {
      this.splide.on("moved", (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.courses.length);

        if (
          lastCardIndex === this.courses.length - 2 &&
          this.courses.length > this.metaCount
        ) {
          this.loadMoreData();
        }
      });
    },

     truncateCourseName(name, maxLength) {
      if (name.length > maxLength) {
        return name.substring(0, maxLength) + "...";
      }
      return name;
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide(".courseSplide", {
            classes: {
              prev: "splide__arrow--prev xx",
              next: "splide__arrow--next xxx",
              arrow: "splide__arrow xxxx",
            },
            perPage: 4,
            perMove: 1,
            rewindByDrag: true,
            gap: "1rem",
            breakpoints: {
              1600: {
                perPage: 4,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              1200: {
                perPage: 3,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 2,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              767: {
                perPage: 1,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: "0rem",
              left: "0rem",
            },
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },
  },
};
</script>

<style>
.card-container-courses {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
